// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__rcPVR","main":"Button_main__Tfp3S","secondary":"Button_secondary__bdwWx"};